<div class="form-container"
     [formGroup]="form" [class.disabled]="disabled">
    <div class="image-upload-content">
        <div class="title"
             *ngIf="!preventInfoTitle && !imageUploadIds?.includes(imageUploadId.LARGE) && !imageUploadIds?.includes(imageUploadId.SMALL)"
             [ngClass]="{'mat-error': form.invalid}">
            {{ (imageUploadIds?.includes(imageUploadId.LOGO) ? 'catalog.common.brandLogo' : 'catalog.common.menuImage') | translate }}
        </div>

        <ng-container *ngIf="selectedImage">
          <ng-container *ngIf="!preventSelector && !imageUploadIds?.includes(imageUploadId.LOGO) &&!imageUploadIds?.includes(imageUploadId.LARGE) &&!imageUploadIds?.includes(imageUploadId.SMALL)">
            <txp-type-selector class="category-selector"
                               [columns]="imageUploadIds?.length === 1 ? 1 : 2"
                               [selected]="selectedImage"
                               [types]="imageTypes"
                               (select)="onSelectImageType($event)">
            </txp-type-selector>
          </ng-container>

          <ng-container *ngFor="let item of form.controls | keyvalue">
            <txp-change-set-notice
              [activeVersion]="selectedVersion"
              [hidden]="item.key !== selectedImage.id"
              [itemChanges]="itemChanges"
              [customDecider]="hasImageChanged.bind(this, item.value, getChangeSetDecoratorKey(item.key))"
              [noticeAlign]="'top'"
              [noticeType]="'icon'"
              [eventDetail]="'decorators.' + getChangeSetDecoratorKey(item.key) + '.images'">
              <txp-file-upload [hidden]="item.key !== selectedImage.id"
                               [formControl]="$any(item.value)"
                               data-qa-label="ImageFileUpload"
                               [accept]="selectedImage.allowedMimeTypes"
                               [label]="'catalog.common.uploadAFile' | translate "
                               [showCrop]="allowCrop"
                               [showResize]="allowResize"
                               [autoResizeChannelId]="autoResize && form.get(selectedImage.id).errors && form.get(selectedImage.id).errors['imageDimensions'] ? selectedImage.id : ''">
              </txp-file-upload>
            </txp-change-set-notice>
          </ng-container>

          <mat-error class="image-error mat-error"
               *ngIf="form.get(selectedImage.id).errors">
            <span *ngIf="form.get(selectedImage.id).errors.fileSize">
                {{ 'catalog.common.invalidFileSize' | translate }}
            </span>
            <span *ngIf="form.get(selectedImage.id).errors.fileType">
                {{ 'catalog.common.invalidFileType' | translate }}
            </span>
            <span *ngIf="form.get(selectedImage.id).errors.imageDimensions">
                {{ 'catalog.common.invalidImageDimensions' | translate }}
            </span>
            <span *ngIf="form.get(selectedImage.id).errors.imageAspectRatio">
                {{ 'catalog.common.invalidImageAspectRatio' | translate }}
            </span>
          </mat-error>
          <div class="instructions">
            <div *ngFor="let item of selectedImage.instructions | keyvalue"
                 [ngClass]="{'mat-error': form.get(selectedImage.id).errors &&
                 form.get(selectedImage.id).errors[item.key]}"
                 [innerHtml]="item.value | translate">
            </div>
          </div>
        </ng-container>
    </div>
</div>
